/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Filter } from '../../../model/Filter';
import { Command } from '../../../model/Command';
import { ListController } from '../../ListController';

class ActionRequestProgMesListController extends ListController {
    /** @ngInject */
    constructor(actionRequestProgMesService, waitSpinnerService, $q, $state, $stateParams, $log, notificationService,
        domainService, siteService, equipmentService, companyService, filterService, counterService, configuration,
                $scope) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.actionRequestProgMesService = actionRequestProgMesService;
        this.domainService = domainService;
        this.siteService = siteService;
        this.equipmentService = equipmentService;
        this.companyService = companyService;
        this.filterService = filterService;
        this.counterService = counterService;
        this.$scope = $scope;
        // mdDataTable doesn't support ES6 syntax with $ctrl variable in templates. That's why we must attach the reload
        // callback to the scope with an arrow function so as it can be called by this component with the correct 'this'
        // binding.
        this.$scope.reload = () => this.reload();
        this.$log.debug('Controller \'ActionRequestProgMesList\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.paging.sort = '-creationDate';
        this.commands = [];
        this.initFilters();

        this.handleRestServiceCall(this.loadFilters(), () => {
            this.initCommands();
            this.reload();
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        });
    }

    /**
     * Initializes the filters available at the top of the view.
     */
    initFilters() {
        this.equipmentFilter = Filter.equalFilterWithValue('equipment.id', this.$stateParams.filter.equipmentId,
            'model.equipment.equipment', 'SELECT', []);

        this.siteFilter = Filter.equalFilterWithValue('equipment.site.id', this.$stateParams.filter.siteId,
            'model.site.site', 'SELECT_AUTOCOMPLETE', [], siteId => this.getFilterEquipments(siteId));

        this.domainFilter = Filter.equalFilterWithValue('equipment.site.domain.id', this.$stateParams.filter.domainId,
            'model.domain.domain', 'SELECT', [], domainId => this.getFilterSites(domainId));

        this.companyFilter = Filter.equalFilterEmpty('delegateeUser.company.id', 'model.actionrequest.delegateecompany',
            'SELECT', []);

        let actionRequestStatuses;
        if (this.$stateParams.filter.equipmentId === undefined) {
            // all action requests
            actionRequestStatuses = ['OPENED', 'COMPLETED'];
        } else {
            // action requests for 1 equipment
            actionRequestStatuses = [];
        }

        this.filters.push(
            Filter.equalFilterEmpty('id', 'ui.id', 'NUMBER'),
            Filter.equalFilterEmpty('diNumber', 'model.actionrequest.dinumber'),
            Filter.actionRequestStatusFilter(actionRequestStatuses),
            this.domainFilter,
            this.siteFilter,
            this.equipmentFilter,
            this.companyFilter,
            Filter.greaterOrEqualDateTimeFilter('creationDate', undefined, 'ui.actionrequest.createdafter'),
            Filter.lowerDateTimeFilter('creationDate', undefined, 'ui.actionrequest.createdbefore')
        );
    }

    /**
     * Initializes the commands available in the view header.
     */
    initCommands() {
        this.commands.push(
            Command.stateCommand('ui.actionrequest.create', 'images/svg/add.svg', 'gmao.actionrequestprogmes.create',
                ['ADMIN', 'ACTION_REQUEST_WRITE']),
            Command.handlerCommand(undefined, 'images/svg/reset.svg', () => this.reload())
        );
    }

    /**
     * Loads data in filters.
     */
    loadFilters() {
        return this.getFilterDomains()
            .then(() => this.getFilterSites(this.domainFilter.value))
            .then(() => this.getFilterEquipments(this.siteFilter.value))
            .then(() => this.getFilterCompanies());
    }

    /**
     * Gets the list of domains.
     *
     * @return {Object[]} Promise providing an array of domains.
     */
    getFilterDomains() {
        return this.filterService.getFilterOptions(this.domainService, this.domainFilter, 'name');
    }

    /**
     * Gets the list of sites for a given domain.
     *
     * @param {Number} [domainId] Domain ID, may be undefined if no domain is selected.
     * @return {Object[]} Promise providing an array of sites.
     */
    getFilterSites(domainId) {
        return this.filterService.getOrClearFilterOptions(this.siteService, this.siteFilter, 'name',
            [Filter.equalFilter('domain.id', domainId)], domainId)
            .then(() => this.getFilterEquipments(this.siteFilter.value));
    }

    /**
     * Gets the list of equipments for a given site.
     *
     * @param {Number} [siteId] Site ID, may be undefined if no site is selected.
     * @return {Object[]} Promise providing an array of equipments.
     */
    getFilterEquipments(siteId) {
        return this.filterService.getOrClearFilterOptions(this.equipmentService, this.equipmentFilter, 'name',
            [Filter.equalFilter('site.id', siteId)], siteId);
    }

    /**
     * Gets the list of companies.
     *
     * @return {Object[]} Promise providing an array of companies.
     */
    getFilterCompanies() {
        return this.filterService.getFilterOptions(this.companyService, this.companyFilter);
    }

    /**
     * Reloads the list of action requests.
     *
     * @return {Promise} A promise providing the list of action requests.
     */
    reload() {
        this.counterService.reloadCount();
        return this.handleRestServiceCall(
            this.actionRequestProgMesService.searchEntities({
                params: this.filterService.buildPagingParams(this.paging),
                data: this.filterService.buildFilters(this.filters)
            }),
            data => {
                this.model.data = data.content;
                this.model.totalElements = data.totalElements;
            }
        );
    }
}

export const actionRequestProgMesListComponent = {
    template: require('./actionrequestprogmes-list.html'),
    controller: ActionRequestProgMesListController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/component/ActionRequestProgMesList.js